export default "__VITE_ASSET__903cd779__"